import { Direction } from '@acin/ui-core/types/src/components/DataTable/components/Headers';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { ISortDirection, ISortInput } from '../../../graphql/generated';
import { useInternalRegulationsQuery } from '../graphql/queries/getRegulations.generated';
import { mapToGraphqlSort } from '../utils';

export const useHomepageRegulations = () => {
  const [activeSorting, setActiveSorting] = useState<ISortInput>({
    field: 'title',
    direction: ISortDirection.Asc,
  });

  const variables = useMemo(
    () => ({
      first: 25,
      input: {
        sort: mapToGraphqlSort(activeSorting.field, activeSorting.direction as ISortDirection),
      },
    }),
    [activeSorting.field, activeSorting.direction],
  );

  const { data, loading, error, fetchMore, refetch } = useInternalRegulationsQuery({
    variables,
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    refetch(variables);
  }, [variables, refetch]);

  const pageInfo = data?.internalRegulations.pageInfo;

  const handleFetchMore = useCallback(() => {
    if (pageInfo?.hasNextPage && !loading) {
      fetchMore({
        variables: {
          after: pageInfo.endCursor,
        },
      });
    }
  }, [pageInfo, loading, fetchMore]);

  const onSort = useCallback((key: string, direction: Direction) => {
    setActiveSorting({ field: key, direction: direction === 'ASC' ? ISortDirection.Asc : ISortDirection.Desc });
  }, []);

  return {
    data,
    loading,
    error,
    pageInfo,
    activeSorting,
    onSort,
    handleFetchMore,
  };
};
